export default __webpack_public_path__ + "static/media/menu-icon.22c28bc5.svg";